module.exports = __webpack_public_path__ + "static/media/file-archive.651eb651.svg";